import React from 'react';
import { Accordion } from 'react-bootstrap';

const DisplayVitals = ({index, playerData}) => {
    if (playerData.age.includes('Child')) {
        return null;
    }

    //Male Genitalia - male, herm, futa
    let showMaleVitals = playerData.gender != 'female';
    //Female Genitalia - female, herm, futa
    let showFemaleVitals = playerData.gender != 'male';

    return (
        <Accordion.Item eventKey={index} className={"pb-1 accordion-body"}>
            <Accordion.Header>
                <h3>
                    Vital Statistics
                </h3>
            </Accordion.Header>
            <Accordion.Body>
                <ul className="kinks-ul-single py-1 ">
                    {playerData.vs_chest > 0 ? <li><strong>Chest: </strong> {playerData.vs_chest}</li> : null}
                    {showFemaleVitals && playerData.vs_cup !== '' ? <li><strong>Cup: </strong> {playerData.vs_cup}</li> : null}
                    {playerData.vs_waist > 0 ? <li><strong>Waist: </strong> {playerData.vs_waist}</li> : null}
                    {showFemaleVitals && playerData.vs_hips > 0 ? <li><strong>Hips: </strong> {playerData.vs_hips}</li> : null}

                    {showMaleVitals && playerData.vs_length !== '' ? <li><strong>Cock Length: </strong> {playerData.vs_length}</li> : null}
                    {showMaleVitals && playerData.vs_girth !== '' ? <li><strong>Cock Girth: </strong> {playerData.vs_girth}</li> : null}
                    {showMaleVitals && playerData.vs_testes !== '' ? <li><strong>Testes: </strong> {playerData.vs_testes}</li> : null}
                    {showMaleVitals && playerData.vs_ejaculate !== '' ? <li><strong>Ejaculate: </strong> {playerData.vs_ejaculate}</li> : null}

                </ul>
            </Accordion.Body>
        </Accordion.Item>)
}

export default DisplayVitals;